import { Component, OnInit, OnDestroy } from '@angular/core';

import { AlertService } from '../../services/alert.service';

@Component({
    selector: 'alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit, OnDestroy {

    constructor(private alertService: AlertService) {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    get alerts() {
        return this.alertService.alerts;
    }

    dismissAlert(alert: any) {
        this.alertService.dismissAlert(alert);
    }
}
